// UserItem.js
'use strict';
import { connect } from 'react-redux';
import sendChatStart from '../action/sendChatStart.js';

import UserItem from '../component/UserItem.jsx';
import getNetworkingData from '../selector/getNetworkingData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getUserData from '../selector/getUserData.js';
import fetchUser from '../action/fetchUser.js';
import { FEATURE_DISPLAY_NAME } from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { userId }) => {
  return {
    isUserFetching: userId
      ? getNetworkingData(state, ['user', userId], 'isFetching')
      : false,
    isUserFetched: userId
      ? getNetworkingData(state, ['user', userId], 'isFetched')
      : false,
    isDisplayNameEnabled:
      getRemoteConfigData(state, FEATURE_DISPLAY_NAME) === 1,
    username: getUserData(state, userId, 'username'),
    displayName: getUserData(state, userId, 'displayName'),
  };
};

const mapDispatchToProps = (dispatch, { userId }) => {
  return {
    sendChatStart: () => dispatch(sendChatStart({ userId })),
    fetchUser: ({ userId }) => dispatch(fetchUser({ id: userId })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserItem);
